<template>
  <v-card
      flat
  >
    <v-card-title
        class="blue--text text--lighten-2"
    >
      {{ $t('radar.list.title') }}
      <v-spacer></v-spacer>
      <RadarFormDialog></RadarFormDialog>
    </v-card-title>
    <v-divider class="light-blue lighten-2"></v-divider>
    <v-card-text
      class="pa-0"
    >
      <v-list>
        <v-list-item v-if="radars.length <= 0">
          <v-list-item-content>
            <RadarFormDialog :simple="false"></RadarFormDialog>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else v-for="(radar, i) in radars" :key="i" @click="openRadar(radar)">
          <v-list-item-icon>
            <v-icon>mdi-radar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="radar.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import RadarFormDialog from './RadarFormDialog'

export default {
  name: 'RadarList',
  components: { RadarFormDialog },
  computed: mapState({
    radars: state => state.radars.radars
  }),
  methods: {
    openRadar (radar) {
      this.$store.commit('blobs/clearCurrentBlobId')
      this.$router.push({ name: 'radar', params: { radarId: radar.id } }).catch(() => {})
    }
  }
}
</script>
